import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import api from "@/lib/api";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

export const APPT_STATUSES = [
  { value: "confirmed", label: "Confirmed", tone: "text-[#008F4D] bg-[#E8F7F0] dark:bg-[#00A85A]/15 dark:text-[#3FD98A]" },
  { value: "completed", label: "Completed", tone: "text-sky-700 bg-sky-50 dark:bg-sky-500/15 dark:text-sky-300" },
  { value: "cancelled", label: "Cancelled", tone: "text-red-600 bg-red-50 dark:bg-red-500/15 dark:text-red-300" },
  { value: "no_show", label: "No Show", tone: "text-amber-700 bg-amber-50 dark:bg-amber-500/15 dark:text-amber-300" },
];

export function AppointmentStatusSelect({ appt, onChanged }) {
  const legacy = { requested: "Requested", declined: "Declined" }[appt.status];
  const value = APPT_STATUSES.some((s) => s.value === appt.status) ? appt.status : undefined;
  const tone = APPT_STATUSES.find((s) => s.value === value)?.tone || "text-slate-600 bg-slate-100 dark:bg-white/10 dark:text-slate-300";
  const change = async (status) => {
    try { await api.put(`/appointments/${appt.id}`, { status }); toast.success(`Marked ${APPT_STATUSES.find((s) => s.value === status).label}`); onChanged?.(status); }
    catch { toast.error("Couldn't update the appointment"); }
  };
  return (
    <Select value={value} onValueChange={change}>
      <SelectTrigger className={cn("h-8 w-[130px] border-0 text-xs font-bold", tone)} onClick={(e) => e.stopPropagation()} data-testid={`appt-status-${appt.id}`}><SelectValue placeholder={legacy || "Set status"} /></SelectTrigger>
      <SelectContent>{APPT_STATUSES.map((s) => <SelectItem key={s.value} value={s.value} data-testid={`appt-status-option-${s.value}`}>{s.label}</SelectItem>)}</SelectContent>
    </Select>
  );
}
